import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from '@auth';
import { Router } from '@angular/router';
import { isCoreApiRequest, SKIP_AUTH_REDIRECT } from './api-host-classifier';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService, private router: Router) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (
                err.status === 401 &&
                this.authService.isAuthenticated() &&
                !request.context.get(SKIP_AUTH_REDIRECT) &&
                isCoreApiRequest(request.url)
            ) {
                // A 401 from a CORE API while authenticated means the session is no
                // longer valid -> redirect to the Unauthorized page. 401s from
                // extensions/optional services (Shopify, analytics, the localhost
                // bridges, etc.) are left for their own callers to handle so they
                // don't take down the whole app.
                this.router.navigate(['/unauthorized']);
            }
            return throwError(err);
        }));
    }
}
